
<footer>
    <div class="footerContainer">
 <div class="container">
     <div class="row">
         <div class="col-12 col-sm-12 col-md-12 col-lg-8">
           <div class="row">
               <div class="col-6 col-md-3 vaccinationServices">
                   <h4 class="accessibility-plugin-ac">Vaccination Services</h4>
                   <ul>
                     <li role="link" tabindex="0" aria-label="Register Members">
                        <a href="{{urls.selfReg}}" target="_blank"    class="accessibility-plugin-ac">  Register Members</a>
                    </li>
                     <!-- <li role="link" tabindex="0" aria-label="Search Vaccination Centers">
                         <a href="#" class="accessibility-plugin-ac"> Search Vaccination Centers</a>
                        </li> -->
                     <li role="link" tabindex="0" aria-label="Book Vaccination Slots">
                         <a href="{{urls.selfReg}}" target="_blank"   class="accessibility-plugin-ac">  Book Vaccination Slots </a>
                        </li>
                     <li role="link" tabindex="0" aria-label="Manage Appointment">
                         <a href="{{urls.selfReg}}" target="_blank"   class="accessibility-plugin-ac">  Manage Appointment</a></li>
                     <li role="link" tabindex="0" aria-label="Download Certificate">
                         <a href="{{urls.selfReg}}" target="_blank"   class="accessibility-plugin-ac">   Download Certificate</a></li>
                   </ul>
               </div>
               <div class="col-6 col-md-3 vaccinationServices">
                <h4 class="accessibility-plugin-ac">Platforms</h4>
                <ul>
                    <!-- <li role="link" tabindex="0" aria-label="Co-WIN International">
                        <a href="#" target="_blank"  class="accessibility-plugin-ac"> Co-WIN International</a>
                    </li> -->
                  <li role="link" tabindex="0" aria-label="Vaccinator">
                     <a href="{{urls.webApp}}" target="_blank"    class="accessibility-plugin-ac"> Vaccinator</a>
                 </li>
                  <!-- <li role="link" tabindex="0" aria-label="Partners">
                      <a href="{{urls.admin}}" target="_blank"   class="accessibility-plugin-ac"> Partners</a>
                     </li> -->
                  <li role="link" tabindex="0" aria-label="Department Login">
                      <a href="{{urls.admin}}" target="_blank"   class="accessibility-plugin-ac">Department Login </a>
                     </li>
                  <li role="link" tabindex="0" aria-label="Verify Certificates">
                      <a href="{{urls.verifyCertificate}}" target="_blank"   class="accessibility-plugin-ac">Verify Certificates</a></li>
                  <li role="link" tabindex="0" aria-label="Vaccination Statistics">
                      <a href="{{urls.dashboard}}" target="_blank"   class="accessibility-plugin-ac">Vaccination Statistics</a></li>
                </ul>
            </div>
            <div class="col-6 col-md-3 vaccinationServices">
                <h4 class="accessibility-plugin-ac">Resources</h4>
                <ul>
                  <!-- <li role="link" tabindex="0" aria-label="Updates & Notification">
                     <a href="#"  class="accessibility-plugin-ac">    Updates & Notifications</a>
                 </li> -->
                  <li role="link" tabindex="0" aria-label=" How To Get Vaccinated">
                      <a href="https://prod-cdn.preprod.co-vin.in/sandbox/assets/pdf/User%20Guide_Citizen%20registration_18%2B.pdf" target="_blank" class="accessibility-plugin-ac">       How To Get Vaccinated</a>
                     </li>
                  <li role="link" tabindex="0" aria-label="Do's and Dont's for Vaccination ">
                      <a href="https://prod-cdn.preprod.co-vin.in/assets/pdf/Dos_and_Donts_for_Citizens.pdf" target="_blank" class="accessibility-plugin-ac">  Dos and Dont's  </a>
                     </li>

                  <li role="link" tabindex="0"
                  [attr.aria-label]="'HEADER.Overview' | translate">
                     <a class="user-manual-link accessibility-plugin-ac"
                     href="https://prod-cdn.preprod.co-vin.in/assets/pdf/CoWIN_Overview.pdf" download    target="_blank">{{'HEADER.Overview' | translate}}
                     </a>
                 </li>
                 <li role="link" tabindex="0"
                     [attr.aria-label]="'HEADER.API_GUIDELINES' | translate">
                     <a class="user-manual-link accessibility-plugin-ac"
                     href="https://prod-cdn.preprod.co-vin.in/assets/docx/CoWINAPIGuidelinesFinal.pdf" download    target="_blank">{{'HEADER.API_GUIDELINES' | translate}}
                     </a>
                 </li>


                </ul>
            </div>
            <div class="col-6 col-md-3 vaccinationServices supportList">
                <h4 class="accessibility-plugin-ac">Support</h4>
                <ul >
                  <li role="link" tabindex="0" aria-label="Frequently Asked Questions">
                     <a routerLink="/faq"  class="accessibility-plugin-ac">Frequently Asked Questions</a>
                 </li>
                 <!-- <li role="link" tabindex="0" aria-label="Contact Us">
                    <a routerLink="/contact-us"  class="accessibility-plugin-ac">Contact Us</a>
                </li> -->



                  <!-- <li role="link" tabindex="0" aria-label="Certificate Corrections">
                      <a href="{{urls.selfReg}}" target="_blank"   class="accessibility-plugin-ac">Certificate Corrections</a>
                     </li> -->
                  <!-- <li role="link" tabindex="0" aria-label="Certificate Not Received">
                      <a href="{{urls.selfReg}}" target="_blank"   class="accessibility-plugin-ac">Certificate Not Received </a>
                     </li> -->
                     <!-- <li role="link" tabindex="0" aria-label="Blocked Accounts">
                        <a href="{{urls.selfReg}}" target="_blank"   class="accessibility-plugin-ac">   Blocked Accounts</a>
                       </li> -->

                       <li role="link" *ngIf="router.url != '/contact-us'" tabindex="0" aria-label="Contact Us">
                        <a routerLink="/contact-us" href="javscript:void(0)" class="accessibility-plugin-ac">Contact Us</a>
                       </li>
                </ul>
            </div>
           </div>
         </div>
         <div class="col-12 col-sm-12 col-md-12 col-lg-4">
            <div class="row ">

                <div class="col-12 helpline">
                    <h4>Contact Us</h4>
                    <p class="accessibility-plugin-ac">Helpline: <span>
                        +<a href="tel:911123978046" class="accessibility-plugin-ac">91-11-23978046</a> ({{'HEADER.Toll free' | translate}}- <a href="tel:1075" aria-label="1075" class="accessibility-plugin-ac">1075</a>)
                    </span>
                    </p>
                    <p class="accessibility-plugin-ac">Technical Helpline: <span><a href="tel:0120-4783222" class="accessibility-plugin-ac">0120-4783222</a></span>
                    </p>
                    <!-- <p class="accessibility-plugin-ac">
                        Email Id: <span><a href="mailto:support@cowin.gov.in" class="accessibility-plugin-ac">support@cowin.gov.in</a></span>
                    </p> -->
                </div>
            </div>
        </div>
     </div>

     <div class="row bottomFooter mt-4">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 copyrightCol">
           <p class="accessibility-plugin-ac" role="presentation" aria-label="Copyright © 2021 COWIN. All Rights Reserved" tabindex="0">
               Copyright © 2021 COWIN. All Rights Reserved
             </p>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 bottomFooterCol ml-auto">
            <div class="row">
                <!-- <div class="col-12 col-sm-12  col-md-12 col-lg-2 ml-auto  bottomFooterLinks1">
                    <a  href="#" class="accessibility-plugin-ac">Agreements</a>
                 </div>
               <div class="col-12 col-sm-12  col-md-12 col-lg-2 ml-auto bottomFooterLinks2">
                <a  href="#" class="accessibility-plugin-ac">
                    Licensing </a>
                </div> -->
                 <div class="col-12 col-sm-12  col-md-12 col-lg-4 ml-auto bottomFooterLinks3">
                        <a  [routerLink]="'/terms-condition'" class="accessibility-plugin-ac">Terms of Service </a>
                </div>
                <div class="col-12 col-sm-12  col-md-12 col-lg-4  bottomFooterLinks4">
                    <a  [routerLink]="'/privacy-policy'" class="accessibility-plugin-ac">
                        Privacy Policy </a>
                </div>
            </div>
     </div>
    </div>

 </div>
</div>
</footer>






